import { EpiBlock } from '@api/types';
import { ContentArea, EditableContentArea } from '@components';
import { useAppSelector } from '@hooks';
import { Selector } from '@reduxjs/toolkit';
import { RootState } from '@store';

export type CachedContentAreaProps = {
  contentAreaName: string;
  selector: Selector<RootState>;
};

export const CachedContentArea = ({ selector, contentAreaName }: CachedContentAreaProps) => {
  const content = useAppSelector(selector) as EpiBlock[];
  return (
    <EditableContentArea property={contentAreaName}>
      <ContentArea content={content} enableNativeOverlay />
    </EditableContentArea>
  );
};
